module.exports = __webpack_public_path__ + "img/question-set-enable-assessment.31fa6844.png";